// @flow
import React, { PureComponent } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';
import { Link } from 'react-router-dom';

import type { BreadcrumbType } from 'types/Settings';

type Props = {
  elements: Array<string | BreadcrumbType>,
  isDark?: boolean,
  breadcrumbStyle?: string
};

class Breadcrumb extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    elements: []
  };

  renderElements = (elements: Array<string | { name: string, to: string }>): any => {
    return elements.map((el, index) => <li key={index}>{this.renderElement(el)}</li>);
  };

  renderElement = (element: string | { name: string, to: string }) => {
    return typeof element === 'string' ? (
      element
    ) : (
      <Link
        to={{
          pathname: element.to
        }}
        title={`Se rendre à la page ${element.name}`}
        role="button"
        tabIndex={0}
      >
        {element.name}
      </Link>
    );
  };

  render() {
    const classNamesBreadcrumb = dynamicClassName('breadcrumb ft-h6 ft-up');
    this.props.breadcrumbStyle && classNamesBreadcrumb.add(this.props.breadcrumbStyle);
    this.props.isDark && classNamesBreadcrumb.add('is-dark');
    return <ol className={classNamesBreadcrumb.build()}>{this.renderElements(this.props.elements)}</ol>;
  }
}
export default Breadcrumb;
